import { h } from 'preact';
import { PLAYER_EVENT } from 'constants/events';
import { BaseAnnotation } from 'rendering/annotations/base_annotation';
import { InvisibleAnnotation } from 'rendering/components/invisible_annotation';

export class VideoAnnotation extends BaseAnnotation {
    constructor(props) {
        super(props);

        this.eventBus.onReplay(PLAYER_EVENT.AVAILABLE, (player, adapter) => {
            this.player = adapter;
            this.forceUpdate();
        })
    }

    shouldComponentUpdate(nextProps) {
        return nextProps.content !== this.contents;
    }

    render() {
        if (this.player) {
            this.player.replaceVideo(this.contents);
        }

        return <InvisibleAnnotation data-content={ this.contents } />;
    }

    get contents() {
        return this.props.content;
    }
}